<template>
  <div class="page-container">
    <el-tabs v-model="activeName" type="card">
      <template v-for="(item,index) in componentConfig">
        <el-tab-pane :key="index" :label="item.label" :name="item.compName">
          <component :is="activeName" :key="activeName" />
        </el-tab-pane>
      </template>
    </el-tabs>

  </div>
</template>

<script>

export default {
  name: 'Payout_Approval',
  components: {
    LargeValuePaymentStep: () => import('./components/LargeValuePaymentStep.vue'),
    StandardValuePaymentStep: () => import('./components/StandardValuePaymentStep.vue')
  },
  data() {
    return {
      activeName: 'StandardValuePaymentStep'
    }
  },
  computed: {

    componentConfig() {
      const list = []
      if (this.$store.getters.isHasAuth('AUTH_CODE_STANDARD_DISBURSEMENT')) {
        list.push({ compName: 'StandardValuePaymentStep', label: this.$t('menu.online_payout') })
      }
      if (['PH', 'TH', 'AE', 'SA', 'VN'].includes(this.$store.getters.curCountry.country_code)) {
        if (this.$store.getters.isHasAuth('AUTH_CODE_LARGE_CREATE_DISBURSEMENT')) {
          list.push({ compName: 'LargeValuePaymentStep', label: this.$t('menu.large_value_payment') })
        }
      }
      return list
    }
  },
  created() {
    if (!this.$store.getters.isHasAuth('AUTH_CODE_STANDARD_DISBURSEMENT')) {
      this.activeName = 'LargeValuePaymentStep'
    }
  }
}
</script>

<style scoped>

</style>
